'use strict';
var listen = require('event-listener');

var blockerConfig = {};

function focus() {
    if (blockerConfig.continue) {
        blockerConfig.continue.focus();
    }
}

function block() {
    blockerConfig.listener = listen(blockerConfig.close, 'blur', focus);
}

function unblock() {
    if (blockerConfig.listener) {
        blockerConfig.listener.remove();
        blockerConfig.listener = null;
    }
}

function init(setup) {
    // Not sure how you handle errors.  May want to check that setup.container/close/continue exist or throw exception.
    // Also may want an isReady variable to set and have the block/unblock/focus functions throw exception not isReady, because init needs to be called first
    blockerConfig.container = document.getElementById(setup.container);
    blockerConfig.close = document.getElementsByClassName(setup.close)[0];
    blockerConfig.continue = document.getElementsByClassName(setup.continue)[0];
    blockerConfig.listener = null;
}

module.exports = {
    init: init,
    focus: focus,
    block: block,
    unblock: unblock,
    config: blockerConfig,
    listen: listen
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/util/blocker.js
 ** module id = 28
 ** module chunks = 0
 **/